export default __webpack_public_path__ + "static/media/jetmade.bbda6e36.png";